import React, { useEffect } from "react";
import { connect } from "react-redux";
import Button from "../../../../../../../../../../../components/ripple/Button";
import styles from './NetworkEditor.module.scss'
import { immutableArraySlice, scrollToAnchor } from "../../../../../../../../../../../helpers/common";
import AddPlaceholder from "./AddPlaceholder";
import { unfoldCard } from "../../../../../../../../../../../components/card/CardAdvanced";

function NetworkEditor({bodyBuilder, app, update, ...props}) {

    useEffect(() => {
        props.foldingContentContext?.recalculateHeight();
        const deleted = app.network?.filter(n => !bodyBuilder.networks?.some(_n => _n.id === n)) || [];
        deleted.map(dp => update({network: immutableArraySlice(dp, app.network)}));
    }, [bodyBuilder.networks]);

    const renderNetworkList = () => {

        if (!bodyBuilder.networks?.length) {

            return (
                <AddPlaceholder
                    title='Create network'
                    onClick={() => {
                        unfoldCard('networks');
                        scrollToAnchor('networks', null, true, 'builder-container');
                        setTimeout(() => {
                            document.getElementById('network-new-field')?.focus?.();
                        }, 200)
                    }}
                    alwaysHidden
                />
            )
        }

        // const networks = sortStringArray(bodyBuilder.networks, false, 'name');
        const networks = bodyBuilder.networks;

        return networks.map((n, i) => {

            const selected = app.network?.includes(n.id);

            return (
                <Button
                    className={styles.list__button}
                    displayType={selected ? 'contained' : 'outlined'}
                    title={n.name}
                    onClick={() => {
                        if (selected) {
                            update({network: immutableArraySlice(n.id, app.network)})
                        } else {
                            update({network: [...(app.network || []), ...[n.id]]})
                        }
                    }}
                    iconRight={selected ? 'fas fa-times-circle' : undefined}
                    visuals={{
                        colorBasic: selected ? ['var(--colorAccentSoft)'] : ['var(--colorAccentLight)'],
                        colorFont: selected ? ['var(--colorFontCommon)'] : ['var(--colorBackgroundContent)'],
                        colorRippleTint: selected ? ['var(--colorAccentLight)'] : ['var(--colorAccentContrast)'],
                        borderRadius: '1.6rem',
                        height: '3.2rem',
                    }}
                    key={i}
                />
            );
        });

    }

    return (
        <div className={styles.list}>{renderNetworkList()}</div>
    )
}

const mapStateToProps = state => ({
    bodyBuilder: state.deployment.bodyBuilder,
});

export default connect(mapStateToProps)(NetworkEditor)